import { IconButton, Tooltip } from "@mui/material";
import { Page } from "@mb-pro-ui/components";
import { EnhancedTable } from "@mb-pro-ui/components/table";
import { Company, RemoteFile } from "../utils/types";
import { useCallback, useEffect, useMemo } from "react";
import { Column, Row } from "react-table";
import { useIntl } from "react-intl";
import { useHistory } from "react-router-dom";

import RefreshIcon from "@mui/icons-material/Refresh";
import AddIcon from "@mui/icons-material/Add";
import { useErrorHandler } from "../hooks/useErrorHandler";
import { useMutation } from "react-query";
import { useApi } from "../utils/ApiProvider";
import { usePageSxProps } from "./styles";
import { APP_NAME } from "../App";

export const RemotefilesPage = () => {
  const { listPageSx } = usePageSxProps();
  const { formatMessage } = useIntl();
  const history = useHistory();
  const api = useApi();

  // TODO: többi előfordulható hiba
  const { errorHandler: onError } = useErrorHandler([
    [
      { status: 401, type: "remotefiles" },
      () => formatMessage({ defaultMessage: "You have no rights for remote file management." }),
      () => {
        history.push("/");
      },
    ],
  ]);

  const companiesQuery = () => api<Company[]>("/companies");
  const filesQuery = () => api<RemoteFile[]>("/remote-files");

  const { mutate: getCompanies, data: companies } = useMutation({ mutationFn: companiesQuery, onError });
  const { mutate: getFiles, data: files, status: queryStatus } = useMutation({ mutationFn: filesQuery, onError });

  const columns = useMemo(
    (): Column<RemoteFile>[] => [
      {
        id: "filename",
        Header: formatMessage({
          defaultMessage: "Filename",
        }),
        accessor: (item) => item.filename,
        width: 75,
      },
      {
        id: "unitid",
        Header: formatMessage({
          defaultMessage: "Helios ID",
        }),
        accessor: (item) => item.unitid ?? "",
        width: 50,
      },
      {
        id: "company",
        Header: formatMessage({
          defaultMessage: "Company",
        }),
        accessor: (item) => companies?.find(({ id }) => id === item.company_ref)?.name ?? "",
        width: 120,
      },
      {
        id: "file",
        Header: formatMessage({
          defaultMessage: "File content",
        }),
        accessor: (item) => item.content,
      },
    ],
    [companies, formatMessage]
  );

  const getRemoteFileList = useCallback(() => getFiles(), [getFiles]);

  const newFile = useCallback(() => {
    history.push("/files/new");
  }, [history]);

  useEffect(() => {
    document.title = `${formatMessage({ defaultMessage: "Files" })} - ${APP_NAME}`;
  }, [formatMessage]);

  useEffect(() => {
    getCompanies();
  }, [getCompanies]);

  useEffect(() => {
    getFiles();
  }, [getFiles]);

  return (
    <Page sx={listPageSx}>
      <EnhancedTable
        columns={columns}
        data={companies && files ? files : []}
        showResultCount
        // getRowProps={rowProps}
        queryStatus={queryStatus}
        overscanCount={5}
        onRowClick={(item: Row<RemoteFile>) => history.push(`/files/${item.original.id}`)}
        postfix={
          <>
            <IconButton
              size="small"
              sx={{
                color: "primary.contrastText",
              }}
              onClick={getRemoteFileList}
            >
              <Tooltip
                title={formatMessage({
                  defaultMessage: "Reload",
                })}
              >
                <RefreshIcon />
              </Tooltip>
            </IconButton>
            <IconButton
              size="small"
              sx={{
                color: "primary.contrastText",
              }}
              onClick={newFile}
            >
              <Tooltip
                title={formatMessage({
                  defaultMessage: "Create new file",
                })}
              >
                <AddIcon />
              </Tooltip>
            </IconButton>
          </>
        }
      />
    </Page>
  );
};

export default RemotefilesPage;
